import React, { useCallback, useState } from "react";
import "../../common/styles/list-style.css";
import {
  Identifier,
  Filter,
  TextInput,
  Datagrid,
  TextField,
  NumberField,
  useTranslate,
  List,
} from "react-admin";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { AppbarGroupsFilter } from "../../common/data-grid-inputs/AppBarGroupsFilter";
import { Void } from "../../common/data-grid-fields/Void";
import { addDays, endOfToday } from "date-fns";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { DatePicker } from "@material-ui/pickers";
import { DriverViolationsListDetail } from "./DriverViolationsListDetail";
import { ArrayField } from "../../common/data-grid-fields/ArrayField";
import { AppbarCompaniesFilter } from "../../common/data-grid-inputs/AppBarCompaniesFilter";
import { useResetListSearchField } from "../../../common/hooks/useResetListSearchField";

interface ViolationsListViewProps {}

const ListFilter = (props: any) => {
  useSearchFields(props, ["driverName"]);
  useResetListSearchField(props);
  return (
    <Filter {...props}>
      <TextInput
        className="violations-list-view-filter search-box"
        label="resources.common.labels.search"
        source="q"
        alwaysOn
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        className="list-view-filter"
        label="resources.hos-violations.labels.dateFrom"
        source="dateFrom"
        alwaysOn
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        className="list-view-filter"
        label="resources.hos-violations.labels.dateTo"
        source="dateTo"
        alwaysOn
      />
    </Filter>
  );
};

export const ViolationsListView = (props: ViolationsListViewProps) => {
  const [selectedGroup, setSelectedGroup] = useState<Identifier>("");
  const translate = useTranslate();
  const [selectedCompanies, setSelectedCompanies] = useState<Array<string>>([]);
  const handleSelectedCompaniesChange = useCallback((e: string[]) => {
    setSelectedCompanies(e);
  }, []);

  const getFilter = () => {
    let retVal: any = {};
    if (selectedGroup) {
      retVal.groupId = selectedGroup;
    }

    if (selectedCompanies?.length) {
      retVal.companyIds = selectedCompanies.join(",");
    }

    return retVal;
  };

  return (
    <div className="content-container">
      <AppbarCompaniesFilter
        selectedCompanies={selectedCompanies}
        onSelectedCompaniesChange={handleSelectedCompaniesChange}
      />
      <AppbarGroupsFilter
        selectedGroup={selectedGroup}
        onSelectedGroupChange={(id) => setSelectedGroup(id)}
      />
      <List
        title="resources.hos-violations.name"
        bulkActionButtons={false}
        actions={<Void />}
        filters={<ListFilter />}
        filter={getFilter()}
        filterDefaultValues={{
          dateFrom: addDays(endOfToday(), -7).toISOString(),
          dateTo: endOfToday().toISOString(),
        }}
        sort={{ field: "driverName", order: "asc" }}
        pagination={false}
        {...props}
      >
        <Datagrid
          optimized
          expand={<DriverViolationsListDetail />}
          rowClick="expand"
        >
          <TextField
            source="driverId"
            label="resources.drivers.labels.driverId"
            sortable={false}
          />
          <TextField
            source="driverName"
            label="resources.hos-violations.labels.fullName"
            sortable={false}
          />
          <NumberField
            source="violationsCount"
            label="resources.hos-violations.labels.violationsCount"
            sortable={false}
          />
          <ArrayField
            displayedElementsCount={2}
            emptyArrayDisplay={translate(
              "resources.hos-violations.labels.noViolations"
            )}
            displayMember="type"
            source="violations"
            label="resources.hos-violations.labels.violations"
            labelTranslationNamespace="appData.violationTypes"
            sortable={false}
          />
        </Datagrid>
      </List>
    </div>
  );
};
